import { useState, useEffect, useContext } from 'react';
import { AppContext } from '@/App';
import axios from 'axios';
import { FileText, ExternalLink, Sparkles } from 'lucide-react';

function Reports() {
  const { API } = useContext(AppContext);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const response = await axios.get(`${API}/reports`, {
        
      });
      setReports(response.data);
    } catch (error) {
      console.error('Error fetching reports:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-12">Loading reports...</div>;
  }

  return (
    <div className="space-y-6" data-testid="reports-page">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Reports</h1>
        <p className="text-gray-600 mt-1">Access and manage all company reports from Google Sheets</p>
      </div>

      {/* Google Sheets Integration Banner */}
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
        <div className="flex items-start space-x-3">
          <Sparkles className="text-blue-600 mt-1" size={24} />
          <div>
            <h3 className="font-bold text-blue-900 text-lg">Google Sheets Integration Coming Next</h3>
            <p className="text-blue-700 text-sm mt-1">
              The Google Sheets integration will be implemented in the next phase. You'll be able to view, sort, and filter all your reports in real-time.
            </p>
          </div>
        </div>
      </div>

      {/* Reports Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reports.map((report) => (
          <div
            key={report.id}
            className="bg-white rounded-xl border border-gray-200 p-6 hover:shadow-lg transition-shadow"
            data-testid={`report-card-${report.id}`}
          >
            <div className="flex items-start space-x-3">
              <div className="bg-blue-50 p-3 rounded-lg">
                <FileText className="text-blue-600" size={24} />
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900">{report.name}</h3>
                <p className="text-sm text-gray-600 mt-1">{report.description}</p>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-gray-100">
              <div className="flex items-center justify-between text-sm">
                <div>
                  <span className="text-gray-500">Source:</span>
                  <span className="text-gray-900 ml-2 font-medium">{report.source}</span>
                </div>
              </div>

              <button
                className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition flex items-center justify-center space-x-2"
                data-testid={`view-report-${report.id}`}
              >
                <ExternalLink size={16} />
                <span>View Report</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Reports;